<template>
</template>

<script>
export default {
  name: "RDChatBot",
  mounted() {
    this.loadRightDeskScript();
  },
  methods: {
    loadRightDeskScript() {
      // Check if the environment variable is present
      if (process.env.VUE_APP_RD_ORGANIZATION_PUBLIC_KEY) {
        window.rightdeskUrl = "https://app.rightdesk.com/";
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = `https://app.rightdesk.com/assets/glass-rd.js`;

        function load() {
          RightDesk.init(process.env.VUE_APP_RD_ORGANIZATION_PUBLIC_KEY);
        }
        script.onload = load;
        document.head.appendChild(script);
      }
    },
  }
};
</script>